const getPetAge = (birth_date: Date | string) => {
  const petBirthDate = new Date(birth_date);
  const petAge = new Date().getFullYear() - petBirthDate.getFullYear();
  const petAgeSuffix = petAge <= 1 ? 'año' : 'años';

  return `${petAge} ${petAgeSuffix}`;
};

export default getPetAge;
